import { useQuery } from '@apollo/client';

import { MY_UNTARGETED_USERS } from '../graphql/query/myUntargetedUsersQuery.graphql';

export const useMyUntargetedUsersQuery = (eventId: string) => {
  return useQuery(MY_UNTARGETED_USERS, {
    variables: { eventId },
    fetchPolicy: 'network-only',
  });
};
